import { changeDocumentsMoveState } from './documentsMoveSlice';
export default changeDocumentsMoveState;
